// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\SessionRuleResponse

import { BookingRuleType } from './enums.gen';

export type SessionRuleApiResponse = {
	type: BookingRuleType.Session;
	sessionIds: Array<string> | null;
};

export type SessionRule = {
	type: BookingRuleType.Session;
	sessionIds: Array<string> | null;
};

export function hydrateSessionRule(data: SessionRuleApiResponse): SessionRule {
	return { ...data };
}